@import "~swiper/swiper.scss";
@import "~swiper/modules/navigation.scss";
@import "~swiper/modules/pagination.scss";

$black:  #000000;
$gray2:  #F0F0F0;
$gray7:  rgba($black, 0.3);
$gray8:  rgba($black, 0.1);

$navigation-button-width: 44px;
$navigation-button-height: 44px;

:host {
  display: block;
}

.swiper-wrapper {
  height: auto;
}

.swiper-slide {
  height: auto;
}

.swiper-button-next, .swiper-button-prev {
  top: calc(50% - (#{$navigation-button-height} / 2));
  width: $navigation-button-width;
  height: $navigation-button-height;
  border-radius: 50%;
  background-color: transparent;
  border: none;
  padding: 0;
  outline: none !important;
  &:focus, &:active {
    svg {
      opacity: 1;
    }
  }
  @media only screen and (max-width : 799.98px) {
    display: none;
  }

  &.swiper-button-disabled {
    display: none;
    visibility: hidden;
  }

  svg {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    opacity: 0;
    background: #101010;
    transition: opacity .2s ease-in-out;

    path {
      fill: #FFFFFF;
    }
  }

  &::after {
    display: none;
  }

  .swiper:hover & {
    svg {
      opacity: 0.5;
    }
  }

  .swiper:hover &:hover,
  .swiper:hover &:active,
  .swiper:hover &:focus {
    svg {
      opacity: 1;
    }
  }
}

.swiper-button-prev {
  svg {
    transform: rotateY(180deg);
  }
}

// fix origin swiper mobile pagination position
.swiper-pagination-bullets {
  display: none;
  @media only screen and (max-width : 799.98px) {
    margin: 10px auto 10px auto;
    display: block;
    &.swiper-pagination-horizontal {
      left: 0;
      transform: none;
      position: relative;
      bottom: 0;
    }
    .swiper-pagination-bullet {
      display: inline-block;
      background: black;
      opacity: .2;

      &.swiper-pagination-bullet-active {
        opacity: 1;
        background: black;
      }
    }
  }
}

.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic, 
.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  @media only screen and (max-width : 799.98px) {
    left: 0;
    transform: none;
  }
}

// material
.swiper-material {
  .swiper-slide  .material-wrapper:not(.hover-active) {
    pointer-events: none;
  }
  .swiper-wrapper {
    height: 100%;
  }
}

.material-wrapper {
  border-radius: var(--covet-pics-material-border-radius);
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  box-sizing: border-box;
  pointer-events: auto;
}

.material-content {
  position: absolute;
  transform: translate3d(0, 0, 0);
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-horizontal .material-content {
  height: 100%;
  width: var(--material-slide-size);
  left: calc(50% - var(--material-slide-size) / 2);
  top: 0;
}

.swiper-material {
  height: var(--material-slide-size);
  width: 100%;
  max-width: 100%;
  &.extra-height {
    height: calc(var(--material-slide-size) + var(--material-slide-extra-height));
  }
}

.material-image {
  border-radius: var(--covet-pics-material-border-radius);
  display: block;
  object-fit: cover;
  position: absolute;
  left: 0%;
  top: 0;
  width: 100%;
  height: 100%;
}

// test ver
.material-wrapper:not(.hover-active) {
  .description.modern-1 {
    &.modern-1.text-review,
    &.modern-1.star-only {
      border: none;
    }
  }
  .description.modern-2 {
    &.modern-2.text-review,
    &.modern-2.star-only {
      border: none;
    }
  }
  covet-pics-gallery-item-detail.modern-3 {
    border: none;
  }
  covet-pics-gallery-item-detail.modern-4 {
    border: 1px solid transparent;
  }
  covet-pics-gallery-item-detail.modern-5 {
    border: 1px solid transparent;
  }
}

.material-wrapper {
  .modern-3.img-wrap.text-review,
  .modern-3.img-wrap.star-only {
    &::before {
      display: none;
    }
  }
}

// test basic
.material-wrapper {
  &.basic-1 {
    border: 1px solid $gray2;

    covet-pics-gallery-item-detail {
      border: none;
      &:hover, &:active, &:focus {
        border: none;
      }
    }
    .material-image {
      border-radius: 0;
    }
  }
  &.basic-1.hover-active {
    &:hover, &:active, &:focus {
      border: 1px solid $gray7;
    }
  }

  &.basic-2 {
    box-shadow: 0 0 0 0 transparent;

    covet-pics-gallery-item-detail {
      box-shadow: 0;
      &:hover, &:active, &:focus {
        box-shadow: 0;
      }
    }
    .material-image {
      border-radius: 0;
    }
    &.basic-2.hover-active {
      &:hover, &:active, &:focus {
        box-shadow: 0 0 0 1px $gray8;
      }
    }

  }
  &.basic-3 {
    box-shadow: 0 0 0 0 transparent;

    covet-pics-gallery-item-detail {
      box-shadow: 0;
      &:hover, &:active, &:focus {
        box-shadow: 0;
      }
    }
    .material-image {
      border-radius: 0;
    }
    &.basic-3.hover-active {
      &:hover, &:active, &:focus {
        box-shadow: 0 0 0 1px $gray8;
      }
    }

  }
  &.basic-4 {
    box-shadow: 0 16px 24px 0 rgba(0,0,0,0.05);

    covet-pics-gallery-item-detail {
      box-shadow: 0;
      &:hover, &:active, &:focus {
        box-shadow: 0;
      }
    }
    .material-image {
      border-radius: 0;
    }
    &.basic-4.hover-active {
      &:hover, &:active, &:focus {
        box-shadow: 0 16px 24px 0 rgba(0,0,0,0.15);
      }
    }

  }
  &.basic-5 {
    border: 1px solid $black;
    box-shadow: 0 0 0 0 $black;

    covet-pics-gallery-item-detail {
      border: none;
      box-shadow: 0;
      &:hover, &:active, &:focus {
        border: none;
        box-shadow: 0;
      }
    }

    .material-image {
      border-radius: 0;
    }

    &.basic-5.hover-active {
      &:hover, &:active, &:focus {
        box-shadow: 0 0 0 0.7px $black;
      }
    }
  }
  &.basic-6 {
    .material-image {
      border-radius: 0;
    }
  }
}